window.$ = require('jquery');
const jquery_ui = require('jquery-ui-dist/jquery-ui.js');

//import {toastAlert} from './rocket-effect/toast-alert';
import CartTimer from './rocket-effect/cart-timer'

import PseudoSlider from './pseudo-slider'

/* LOADER
-------------------------------------------------------------------------------------------------------  */
$('.promo-slider').ready (function () {
    $('.loader').fadeOut(50);
});

$(document).ready(function(){

    /* STYLES FOR FORM COMPONENTS
    -------------------------------------------------------------------------------------------------------  */
    style_form_fields();

    $('.gform_button.button').on('click', function(e){
        let intTimer = setInterval( checkErrors, 500);

        function checkErrors() {
            if ( $('.validation_message').length > 0) {
                style_form_fields();
                clearInterval(intTimer);
            }
        }
    });

    /* ADD PLACEHOLDER FOR SELECTS
    -------------------------------------------------------------------------------------------------------  */
    $.widget( 'app.selectmenu', $.ui.selectmenu, {
        _renderButtonItem: function (item) {
            var buttonItem = window.$('<span>', {
                'class': 'ui-selectmenu-text'
            });

            var placeholder = this.options.placeholder;

            if (!item.index && placeholder) {
                this._setText(buttonItem, placeholder)
            } else {
                this._setText(buttonItem, item.label)
            }

            return buttonItem
        },
    });

    /* HORIZONTAL FILTER
    -------------------------------------------------------------------------------------------------------  */
    // $('.movie-booking-date-selector .selector-container').on('click', function (e) {
    //     let filer = e.target.className;
    //     if(filer.indexOf('selector-container') != -1) {
    //        $(this).toggleClass('show-list');
    //    }
    // });

    // $('.movie-booking-date-selector .selector-container .date-option-container').on('click', function () {
    //     $('.movie-booking-date-selector .selector-container.vertical .date-option-container').removeClass('active');
    //     $(this).addClass('active');
    // });
    //
    // $('.movie-booking-date-selector .selector-container .selected').parent().addClass('active');
    /* CHECKOUT CART PADDING FOR TABLE
    -------------------------------------------------------------------------------------------------------  */
    let bookedItems = $('.shopping-cart-item');

    for(let i=0; i< bookedItems.length; i++) {
        let titleHeight = bookedItems.eq(i).find('.movie-item-title').height();
        bookedItems.eq(i).find('.movie-item-middle-panel').css('paddingTop', titleHeight + 15);
    }

    /* BILLY'S GRILLE MENU SLIDER
    -------------------------------------------------------------------------------------------------------  */
    jQuery('.category-slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });

    /* SOCIAL SLIDERS
    -------------------------------------------------------------------------------------------------------  */
    var instagramTimer = setInterval(function () {
        if ( $('.sbi_item').length > 0 ) {
            insatgram_feed();
            clearInterval(instagramTimer);
        }
    }, 100);

    var fbTimer = setInterval(function () {
        if ( $('.sbi_item').length > 0 ) {
            facebook_feed();

            $(".tab-list-item.facebook").on("click", function() {
                $('#facebook .slick-next').click();
                $(".fts-powered-by-text-popup a.fts-powered-by-text").remove();
            });

            clearInterval(fbTimer);
        }
    }, 100);

    /* BUTTON MENU BURGER
    -------------------------------------------------------------------------------------------------------  */
    $('.btn-menu-js').on('click', function() {
        $(".primary-menu").toggleClass("opened");
        $("body").toggleClass("overflow");
        $(".btn-menu--closed, .btn-menu--opened").toggle();
        $(".location, .registration").toggleClass("show");
    });

    /* OPENED SECOND LEVEL OF MAIN MENU
        -------------------------------------------------------------------------------------------------------  */
    $('.primary-menu .menu-item-has-children').on('click', function() {
        $(this).toggleClass("show-children");
    });

    /* CHECK IF WE ARE IN ADMIN PANEL
        -------------------------------------------------------------------------------------------------------  */
    if ( $('#wpadminbar').length > 0) {
        $('.primary-menu').addClass('inwpadmin');
    }

    /* SIGNATURE
    -------------------------------------------------------------------------------------------------------  */
    jQuery('.ginput_container.signature_wrapper').html('<div class="sig sigWrapper">\n' +
        '      <div class="typed"></div>\n' +
        '      <canvas class="pad" width="500" height="220"></canvas>\n' +
        '      <input type="hidden" name="output" class="output">\n' +
        '      <input type="button" name="clear" class="clear" value="Clear">\n' +
        '    </div>');

    // Initialization signaturePad on current page (9 page)
    jQuery('body').on('click', function(e) {
        if(e.target.className == 'gform_next_button button') {
            var intv = setInterval(function() {
                var gform_pages = jQuery('.gform_page');
                for(var j = 0; j < gform_pages.length; j++) {
                    var el = jQuery('.gform_page:eq('+j+')');

                    if(el.css('display') === 'block' && el.find('.signature_wrapper').length > 0) {
                        jQuery('.hiring-form').signaturePad({
                            drawOnly: true
                        });
                        clearInterval(intv);
                        break;
                    }
                }
            },100);
        }
    });

    // Initialization clear button
    jQuery('body').on('click', 'input[name="clear"]', function() {
        var c=document.getElementsByTagName("canvas")[0];
        var ctx=c.getContext("2d");
        ctx.fillStyle="white";
        ctx.fillRect(0,0,500,220);
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#ccc';
        ctx.moveTo(5, 80);
        ctx.lineTo(500 - 5, 80);
        ctx.stroke();
        ctx.closePath();
    });

    // Get json data and insert information to input
    jQuery('body').on('click', '.pad', function() {
        var api = jQuery('.hiring-form').signaturePad({
            drawOnly: true
        });
        var json = api.getSignatureString();
        if(json  !== '[]') {
            jQuery.ajax({
                type: "POST",
                url: window.wp_data.ajax_url,
                data: {
                    action : 'ajax_request',
                    post_name : json
                },
                success: function(data) {
                    jQuery('#input_6_89, #input_7_89').val(data);
                }
            });
        }
    });

    /* CINEMA HALL HIDE/SHOW
    -------------------------------------------------------------------------------------------------------  */
    $(".hide-cinema-hall-js").on('click', function (e) {
        $(".booking__cinema-hall").toggle(30);
    });

    /* CLOSE BUTTON
    -------------------------------------------------------------------------------------------------------  */
    $('.close-btn-js').on('click', function (e) {
        if ($(".primary-menu").hasClass("opened")) {
            $(".primary-menu").removeClass("opened");
            $(".location, .registration").removeClass("show");
        }
    });

    /* VIDEO POPUP
    -------------------------------------------------------------------------------------------------------  */
    $('.open-video-popup-js').on('click', function(e) {
        $('.video-overlay-js').show(20);
    });

    $('body').on('click', function (e) {
        let video = $(".video")[0];

        if(e.target.className !== 'video' && e.target.className !== 'section-content__media open-video-popup-js') {

            $('.video-overlay-js').fadeOut(50);

            if (video && ! video.paused ) {
                $(".video")[0].pause();
            }
        }

        if (navigator.userAgent.indexOf('Chrome') !== -1) {
            if(e.target.className == 'video') {
                if ( ! video.paused ) {
                    video.pause();
                } else (
                    video.play()
                )
            }
        }
    });

    /* FIXED HEADER
    -------------------------------------------------------------------------------------------------------  */
    $(window).on('scroll', function() {
        let scrollTop = $(window).scrollTop();

        if ( scrollTop > 0 ) {
            $('.header, .info-block').addClass("fixed");
            $('body').addClass("fixed-header");

        } else {
            $('.header, .info-block').removeClass("fixed");
            $('body').removeClass("fixed-header");
        }
    });

    /* ANIMATION FOR ANCHOR
    -------------------------------------------------------------------------------------------------------  */
    let headerHeight = $('.header').height();
    $(document).on('click', 'a[href*="#"]', function (event) {
        event.preventDefault();

        let menuUrl = $(this).attr('href');
        let pos = menuUrl.indexOf('#')+1;
        let menuAnchor = menuUrl.substr(pos);

        Cookies.set('menu-anchor', '#'+ menuAnchor, {expires: 7});

        if(menuUrl.indexOf(location.href) == -1 || location.pathname == "/") {
            location.href = menuUrl.substr(0, pos);
        } else {
            let currentMenuAnchor =  Cookies.get('menu-anchor');
            if (currentMenuAnchor && currentMenuAnchor != '#') {
              $('html, body').animate({
                  scrollTop: $(Cookies.get('menu-anchor')).offset().top - headerHeight
              }, {
                  duration:1000,
                  done: function () {
                      Cookies.set('menu-anchor',null);
                  }
              })
            }
        }
    });

    let currentMenuAnchor = Cookies.get('menu-anchor');
    if(currentMenuAnchor != null && currentMenuAnchor !== '#' && $(currentMenuAnchor).length > 0) {

        window.setTimeout(function () {
          $('html, body').animate({
              scrollTop: $(Cookies.get('menu-anchor')).offset().top - headerHeight
          }, 500);
          Cookies.set('menu-anchor',null);
        }, 0);

    }

    /* REMOVED CLASS FROM OWL SLIDER, THAT AUTOMATICALLY HIDE ARROWS
    -------------------------------------------------------------------------------------------------------  */
    $(".owl-nav, .owl-carousel").removeClass("autohide-arrows");

    /* TABS
    -------------------------------------------------------------------------------------------------------  */
    $(".tabs .tab-list-item:first-child").addClass('active');
    $(".tab-content-wrapper .tab-item:first-child").addClass('active');

    $(".tabs .tab-list-item").on('click', function(e) {
        const category = $(this).data('category');
        $(".tabs .tab-list-item, .tab-content-wrapper .tab-item").removeClass('active');
        $(this).addClass('active');
        $('#'+category).addClass('active');
        console.log('#'+category);
    });

    /* LOCATION SWITCH
    -------------------------------------------------------------------------------------------------------  */
    $(".location-header").on('click', function(e) {
        $(this).toggleClass('opened');
        $('.primary-menu').toggleClass('opened-location');
    });

    if ($(window).width() >= 767) {
        $(".location-list-js").on('click', function(e) {
            $(this).toggleClass('opened');
            $('.primary-menu').toggleClass('opened-location');
        });
    }

    $(".location-list-item-js").on('click', function() {
        $(".location-list-item").removeClass('active');
        $(this).addClass('active');
    });
});

function insatgram_feed() {
    jQuery('#sbi_images').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}

function facebook_feed() {
    jQuery('.fts-simple-fb-wrapper').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })
}

function style_form_fields() {
    $('select:not([vue-based1])').each(function(i, el) {
        el = $(el)
        el.selectmenu({
            appendTo: el.parent()
        });
    });

    $('input').attr('autocomplete', 'off');

    $( ".datepicker, .input-date input" ).datepicker({
        minDate: 'today'
    });
}
